import getData from './request/request'
import $http from './http'
async function getButton(val) {
    let Api = {
        url: '/api/getbutton',
        type: 'post'
    }
    let form = {
        type: val,
    }
    let res = await getData($http(Api, form))
    console.log(res.code)
}

export default getButton


// WEBPACK FOOTER //
// ./src/utils/getButton.js